export const EXCLUDED_TAG_NAMES = [
  'script',
  'noscript',
  'style',
  // svg elements:
  'path',
  'circle',
  'rect',
  'ellipse',
  'line',
  'polygon',
  'polyline',
  'g',
];

export const DATA_UW_IGNORE = 'data-uw-ignore';
export const DATA_UW_ELEMENT = 'data-uw-rm-ignore';

export const EXCLUDED_ATTRIBUTES = [DATA_UW_IGNORE, DATA_UW_ELEMENT];
